import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RaciNavigationService } from '../../../../navigation/raci-navigation.service';
import { RaciService } from '../../../raci/services/raci.service';
import { ValoremIntegrationService } from '../../services/valorem-integration.service';

/**
 * Handles the valorem publish task component
 */
@Component({
  selector: 'valorem-publish-task',
  templateUrl: './valorem-publish-task.component.html',
  styleUrls: ['./valorem-publish-task.component.css']
})
export class ValoremPublishTaskComponent {
  /**
   * The current step
   */
  currentStep = 1;

  /**
   * The publish data
   */
  publishData: any;

  /**
   * Indicates whether to display an error
   */
  displayError: boolean;

  /**
  * The active valuation event ID
  */
  activeValuationEventId: number;

  /**
   * The valuation event ID
   */
  @Input() set valuationEventId(value: number) {
    if (value) {
      this.activeValuationEventId = value;
    }
  }

  /**
   * Event emitter for publishing information change
   */
  @Output() onPublishInformationChange: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Constructor
   * @param _raciService RaciService
   * @param valoremIntegrationService ValoremIntegrationService
   */
  constructor(private _raciService: RaciService,
    private valoremIntegrationService: ValoremIntegrationService,
    private _raciNavigationService: RaciNavigationService) { }

  /**
  * Publish to valorem
  */
  publishTovalorem() {
    this._raciService.displayDataLoader(true);
    this.currentStep = 0;
    this.valoremIntegrationService.publish(this.activeValuationEventId).subscribe({
      next: (publishData) => {
        if (publishData) {
          this.publishData = publishData;
          this.onPublishInformationChange.emit(publishData);
          this.currentStep = 2;
        }
        this._raciService.displayDataLoader(false);
      },
      error: (error) => {
        this._raciService.displayDataLoader(false);
        this.displayError = true;
        this.currentStep = 2;
      }
    });
  }

  /**
  * On close sidebare
  */
  onCloseClicked() {
    this._raciNavigationService.onUpdatePublishToValoremActiveStatus(false);
    this._raciNavigationService.onDisplayPublishToValorem(false);
  }
}
